<template lang="pug">

    form.ui.grid.form#login(v-on:submit.prevent='login()')

        .column.centered.row
            .five.wide.column

                .ui.segments
                    .ui.segment
                        .ui.fluid.transparent.left.icon.input
                            input(placeholder='Benutzername' autocomplete='username' ref='Username' v-model="username")
                            i.user.icon
                    .ui.segment
                        .ui.fluid.transparent.left.icon.input
                            input(type='password' placeholder='Passwort' autocomplete='current-password' ref='Password' v-model="password")
                            i.lock.icon

        .column.centered.row(v-if='errorMessage')
            .five.wide.column
                .ui.red.message
                    i.warning.icon
                    | {{ errorMessage }}

        .column.centered.row
            .five.wide.column
                button.primary.ui.right.labeled.icon.right.floated.button Login
                    i.right.arrow.icon

</template>

<script>
    import { default_route } from '@/utils/role'

    //noinspection JSUnusedGlobalSymbols
    export default {

        data() {
            return {
                username: '',
                password: '',
                errorMessage: ''
            }
        },

        methods: {

            async login() {

                // Vorherigen Fehler zurücksetzen
                this.errorMessage = ''

                // Login absenden
                await this.$auth.login(this.username, this.password)
                    .then(() => {
                        // Zur vorherigen Seite zurückkehren, falls eine Redirect-Query gesetzt ist
                        const redirect = this.$route.query.redirect
                        if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
                            this.$router.push(redirect)
                            return
                        }

                        // Standard-Route fuer Rolle ermitteln
                        const route = default_route(this.$auth.activeRoleId)

                        // Weiterleitung auf Produktpage
                        this.$router.push(route)
                    })
                    .catch(error => {

                        // Fehlermeldung ermitteln (403 = falsche Zugangsdaten)
                        const status = error.response && error.response.status
                        this.errorMessage = status === 403
                            ? 'Benutzername oder Passwort ist falsch'
                            : 'Service momentan nicht verfügbar. Bitte an den Support wenden.'

                        // Passwort leeren
                        this.password = ''
                    })
                        
            }

        },

        mounted() {
            this.$refs.Username.select()
        },

    }

</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

    #login {
        margin-top: 10%;
    }

    button {
        visibility: visible;
    }

</style>
